/**
* 基础菜单 会员服务管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>会员服务管理</el-breadcrumb-item>
        <el-breadcrumb-item>商品咨询管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <div class="block">
          <el-date-picker
            v-model="question_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_name" placeholder="商品名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.cust_name" placeholder="提问人" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.question_content" placeholder="提问内容" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="reply" class="add-button">回复</el-button>
        <el-button size="small" type="success" @click="addtion" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editupdate" class="edit-button">修改</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" min-width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_name" label="商品名称" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="question_content" label="提问内容" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="cust_name" label="提问人" width="136" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="question_time" label="提问时间" width="190" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="answer_content" label="回复内容" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="answer_user_name" label="回复人" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="answer_time" label="回复时间" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 回复弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="回复"
               :visible.sync="replyDialogVisible"
               width="30%"
               :before-close="handleBrandClose"
               center>
      <el-form :model="questionForm" :rules="questionRules" ref="questionForm" label-width="125px" class="brandForm">
          <el-form-item label="提问内容" prop="question_content">
            <el-input
              type="textarea"
              v-model="questionForm.question_content"
              maxlength="200"
              :autosize="{ minRows: 4, maxRows: 10}"
              show-word-limit
              resize="none"
              auto-complete="off"
              clearable
              :disabled="isDisable"
            >
            </el-input>
          </el-form-item>
        <el-form-item label="回复内容" prop="answer_content">
          <el-input
            type="textarea"
            placeholder="请输入回复内容"
            v-model="questionForm.answer_content"
            maxlength="100"
            :autosize="{ minRows: 2, maxRows: 4}"
            show-word-limit
            resize="none"
            auto-complete="off"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleBrandClose">取消</el-button>
            <el-button type="primary" @click="questionFirm('questionForm')">确认</el-button>
      </span>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="labelDialogVisible"
               width="30%"
               :before-close="labelBrandClose"
               center>
      <el-form :model="labelForm" :rules="labelRules" ref="labelForm" label-width="125px" class="brandForm">
        <el-form-item label="商品销售名称" prop="product_id" class="relative">
          <el-select v-model="labelForm.product_id" filterable placeholder="请选择商品销售名称" clearable :disabled="isDisable"
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName()" @clear="clear()">
            <el-option :title="item.sale_name" style="width: 320px;"
                       v-for="item in productData"
                       :key="item.product_id"
                       :label="item.sale_name"
                       :value="item.product_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="提问人" prop="cust_id" >
          <el-select v-model="labelForm.cust_id" filterable placeholder="请选择提问人" clearable
                     :popper-append-to-body="false" @focus="custFocusProductName()" :disabled="isDisable"
                     @change="custChangeProductName()" @clear="custClear()">
            <el-option :title="item.mobile" style="width: 320px;"
                       v-for="item in custData"
                       :key="item.id"
                       :label="item.mobile"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提问内容" prop="question_content" class="discuss">
          <el-input
            type="textarea"
            placeholder="请输入提问内容"
            v-model="labelForm.question_content"
            maxlength="200"
            :autosize="{ minRows: 4, maxRows: 10}"
            show-word-limit
            resize="none"
            auto-complete="off"
            clearable
            :disabled="isDisable"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="回复内容" prop="answer_content" class="discuss">
          <el-input
            type="textarea"
            placeholder="请输入回复内容"
            v-model="labelForm.answer_content"
            maxlength="200"
            :autosize="{ minRows: 4, maxRows: 10}"
            show-word-limit
            resize="none"
            auto-complete="off"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="labelBrandClose">取消</el-button>
            <el-button type="primary" @click="labelFirm('labelForm')">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    questionList,questionAdd,questionUpdate,questionReply,questionDetail,questionAddDetail,productSaleList,productList,flashDetail,questionCustList
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, // 显示加载
        replyDialogVisible: false, // 控制页面显示与隐藏
        labelDialogVisible: false,
        dialogTitle: '', // 标题
        productId: '',
        selectTableData: [],
        formInline: {
          page: 1,
          rows: 10,
          product_name: '',
          product_code: '',
          cust_name: '',
          start_question_time: '',
          end_question_time: '',
          question_content: '',
          discuss_content: '',
          discuss_type: '',
          star_degree: '',
          approval_status: ''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // cust_id: localStorage.getItem('order_time'),
        questionForm: {
          id: '',
          answer_content: '',
          answer_id: '',
        },
        labelForm: {
          id: '',
          question_content: '',
          answer_content: '',
          product_id: '',
          cust_id: '',
        },
        questionData: {},
        // rules表单验证
        questionRules: {
          answer_content: [{ required: true, message: '请输入回复内容', trigger: 'blur' }],
          question_content: [{ required: true, message: '提问内容不能为空', trigger: 'blur' }],
        },
        labelRules: {
          question_content: [{required: true, message: '提问内容不能为空', trigger: 'blur'}],
          answer_content: [{required: true, message: '回复内容不能为空', trigger: 'blur'}],
          product_id: [{required: true, message: '请选择商品销售名称', trigger: 'blur'}],
          cust_id: [{required: true, message: '请选择提问人', trigger: 'blur'}],
        },
        product_id: '',
        cust_id: '',
        answer_id: '',
        question_time: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        saleName: '',
        selectedsaleName: '',
        saleGiftName: '',
        productData: [],
        small: true,
        custName: '',
        custSaleName: '',
        custData: [],
        id: '',
        mobile: '',
        isDisable: false,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        questionList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        if (this.question_time) {
          this.formInline.start_question_time = timestampToDate(this.question_time[0])
          this.formInline.end_question_time = timestampToDate(this.question_time[1])
        } else {
          this.formInline.start_question_time = ''
          this.formInline.end_question_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 回复
      reply() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].answer_content) {
          this.$message.error('您已回复过此商品咨询，不能再次回复！');
          return
        }
        this.replyDialogVisible = true;
        this.isDisable = true;
        this.productId = this.selectTableData[0].id;
        this.answer_id = this.selectTableData[0].answer_id;
        this.questionForm = {
          id: '',
          answer_content: '',
        },
        this.questionForm.question_content = this.selectTableData[0].question_content;
        questionDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
                this.labelForm = {
                  id: res.content.id,
                  question_content: res.content.question_content,
                  answer_content: res.content.answer_content,
                  answer_id: res.content.answer_id,
                }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      questionFirm(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.questionForm.id = this.productId;
            this.loading = true;
            questionReply(this.questionForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功回复!'
                  })
                  this.replyDialogVisible = false;
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false;
                this.$message.error('网络错误,请稍后再试!')
              })
          } else {
            console.log('error submit!!');
          }
        })
      },
      custFocusProductName() {
        if (!this.custSaleName) {
          this.custName = ''
          this.getCust('')
        }
      },
      custChangeProductName() {
        this.custData.forEach((item) => {
          if (item.id == this.labelForm.id) {
            this.custSaleName = item.mobile;
            this.getCust(item.mobile)
          }
        })
      },
      custClear() {
         this.getCust()
         this.productCurrentPage = 1
         this.custName = ''
      },
      getCust(custName) {
        let parameter = {
          mobile: custName,
        };
        questionCustList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
                if (res.success) {
                  this.custData = res.content;
                }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 新增
      addtion() {
        this.labelDialogVisible = true;
        this.dialogTitle = '新增咨询';
        this.isDisable = false;
        this.labelForm = {
          id: '',
          question_content: '',
          answer_content: '',
          cust_id: '',
          product_id: '',
        };
        this.selectedsaleName = '';
        this.custSaleName = '';
      },
      // 修改
      editupdate() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.labelDialogVisible = true;
        this.dialogTitle = '修改咨询';
        this.labelForm.cust_id = this.selectTableData[0].cust_name;
        this.isDisable = true;
        let parameter = {
          page: 1,
          rows: 10,
          saleName: this.selectTableData[0].sale_name,
          productCode: '',
          putaway: '75',
          brandName: ''
        };
        productList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.selectedsaleName = this.selectTableData[0].sale_name;
              this.productData = res.content
              this.productTotalSize = res.totalSize
            }
          })
        questionDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.labelForm = {
                id: res.content.id,
                question_content: res.content.question_content,
                answer_content: res.content.answer_content,
                product_id: res.content.product_id,
                cust_id: res.content.cust_name
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      labelFirm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增咨询') {
              questionAdd(this.labelForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增咨询'
                    });
                    this.labelDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.labelForm.id = this.productId;
              questionUpdate(this.labelForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改咨询'
                    });
                    this.labelDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      handleBrandClose() {
        this.replyDialogVisible = false;
      },
      labelBrandClose() {
        this.labelDialogVisible = false;
      },
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      changeProductName() {
        this.productCurrentPage = 1
        this.productData.forEach((item) => {
          if (item.product_id == this.labelForm.product_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.product_code == cell.innerText || row.cust_name == cell.innerText || row.question_content == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .voucherForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .voucherForm .el-input {
    width: 320px;
  }

  /deep/ .voucherForm .el-input--small {
    width: 320px;
  }

  /deep/ .sortForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .sortForm .el-input {
    width: 320px;
  }

  /deep/ .sortForm .el-input--small {
    width: 320px;
  }

  /deep/ .brandForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .brandForm .el-input {
    width: 320px;
  }

  /deep/ .brandForm .el-input--small {
    width: 320px;
  }

  2000000000000000.7-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .f14 {
    font-size: 14px;
  }

  .lh40 {
    line-height: 40px;
  }

  .mb22 {
    margin-bottom: 22px;
  }

  .flex_box {
    display: flex;
  }

  .billing_item span {
    line-height: 22px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .label {
    width: 125px;
    height: 32px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    padding: 5px 12px 5px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  /deep/ .discuss .el-textarea {
    width: 320px;
  }

  .label:before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
  }

  .pagination-absolute {
      position: absolute;
      bottom: 0;
      background: #fff;
      width: 94%;
      padding-left: 20px;
      height: 40px;
  }

  /deep/ .brandForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

</style>





// WEBPACK FOOTER //
// src/views/service/Productconsultation.vue